<div class="container-fluid py-20 px-30">
  <div class="d-flex justify-content-between align-items-center mb-20">
    <h4 class="mb-0">Payment Matching</h4>
    <div class="d-flex align-items-center">
      <div class="text-end me-15">
        <div class="form-check form-switch mb-0 d-inline-flex align-items-center">
          <input
            id="payment-matching-auto-mode"
            class="form-check-input me-8"
            type="checkbox"
            [checked]="autoMatchingEnabled"
            [disabled]="autoMatchingLoading || !settingsLoaded"
            (change)="toggleAutoMatching()" />
          <label class="form-check-label fw-medium" for="payment-matching-auto-mode">Auto-matching</label>
        </div>
        <div class="text-muted small mt-4">
          {{ autoMatchingEnabled ? 'New matches are approved automatically.' : 'New matches stay pending review.' }}
        </div>
      </div>
      <button class="btn btn-primary btn-sm" (click)="checkNow()" [disabled]="checkNowLoading">
        <span *ngIf="checkNowLoading" class="spinner-border spinner-border-sm me-1" role="status"></span>
        {{ checkNowLoading ? 'Checking...' : 'Check Now' }}
      </button>
    </div>
  </div>

  <!-- Bank Accounts -->
  <div class="mb-20">
    <div class="d-flex justify-content-between align-items-center mb-10">
      <h6 class="mb-0">Bank Accounts</h6>
      <button class="btn btn-outline-primary btn-sm" (click)="syncBankAccounts()" [disabled]="syncLoading">
        <span *ngIf="syncLoading" class="spinner-border spinner-border-sm me-1" role="status"></span>
        {{ syncLoading ? 'Syncing...' : 'Sync from Zoho' }}
      </button>
    </div>
    <div class="row" *ngIf="bankAccounts.length > 0">
      <div class="col-md-4 col-lg-3 mb-10" *ngFor="let account of bankAccounts">
        <div class="card" [class.opacity-50]="!account.enabled">
          <div class="card-body py-10 px-15">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <div class="fw-bold">{{ account.accountName }}</div>
                <small class="text-muted" *ngIf="account.lastCheckedAt">
                  Last checked: {{ account.lastCheckedAt | date: 'dd MMM yyyy HH:mm' }}
                </small>
                <small class="text-muted" *ngIf="!account.lastCheckedAt">Never checked</small>
              </div>
              <div class="form-check form-switch ms-10">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="account.enabled"
                  [disabled]="toggleInProgress[account.id]"
                  (change)="toggleBankAccount(account)" />
              </div>
            </div>
            <div class="form-check mt-10 mb-0">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'near-amount-' + account.id"
                [checked]="account.allowNearAmountMatching"
                [disabled]="toggleInProgress[account.id] || !account.enabled"
                (change)="toggleNearAmountMatching(account)" />
              <label class="form-check-label small" [for]="'near-amount-' + account.id"> Allow near-amount deposits </label>
            </div>
            <div class="form-check mt-6 mb-0">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'categorization-' + account.id"
                [checked]="account.allowCategorization"
                [disabled]="toggleInProgress[account.id] || !account.enabled"
                (change)="toggleCategorization(account)" />
              <label class="form-check-label small" [for]="'categorization-' + account.id"> Allow categorization </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="bankAccounts.length === 0" class="text-muted">No bank accounts configured. Click "Sync from Zoho" to import.</div>
  </div>

  <ul class="nav nav-tabs mb-15">
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'matches'" href="javascript:void(0)" (click)="activeTab = 'matches'">Matches</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'categorization'" href="javascript:void(0)" (click)="activeTab = 'categorization'">
        Categorization
      </a>
    </li>
  </ul>

  <!-- Matches Table -->
  <div *ngIf="activeTab === 'matches'">
    <div class="d-flex justify-content-end align-items-center mb-10">
      <label for="payment-match-status" class="form-label mb-0 me-8">Status</label>
      <select
        id="payment-match-status"
        class="form-select status-filter"
        [value]="selectedStatus || ''"
        [disabled]="loadingMatches"
        (change)="onStatusFilterChange($any($event.target).value)">
        <option value="">All statuses</option>
        <option *ngFor="let status of matchStatuses" [value]="status.value">{{ status.label }}</option>
      </select>
    </div>
    <div class="table-responsive">
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th>Date</th>
            <th>Status</th>
            <th>Bank Account</th>
            <th>Amount</th>
            <th>Difference</th>
            <th>Payee</th>
            <th>Invoice</th>
            <th>Inv Number</th>
            <th>Confidence</th>
            <th>Tx ID</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loadingMatches">
            <td colspan="11" class="text-center py-20"><span class="spinner-border spinner-border-sm" role="status"></span> Loading...</td>
          </tr>
          <tr *ngIf="!loadingMatches && matches.length === 0">
            <td colspan="11" class="text-center py-20 text-muted">No matches found</td>
          </tr>
          <tr *ngFor="let match of loadingMatches ? [] : matches">
            <td class="text-nowrap">{{ formatTransactionDate(match.transactionDate) }}</td>
            <td>
              <span class="badge" [ngClass]="getStatusBadgeClass(match.status)">{{ match.status }}</span>
            </td>
            <td class="text-nowrap">{{ match.bankAccountName }}</td>
            <td class="text-nowrap">{{ formatAmount(match.transactionAmountEur) }}</td>
            <td class="text-nowrap">{{ match.amountDifferenceEur > 0 ? formatAmount(match.amountDifferenceEur) : '-' }}</td>
            <td class="payee-cell">
              <span class="payee-text" [title]="match.transactionReference">{{ match.transactionReference }}</span>
            </td>
            <td class="text-nowrap">
              <a href="javascript:void(0)" (click)="viewInvoice(match.invoiceId)">{{ match.invoiceId | slice: 0 : 8 }}…</a>
            </td>
            <td class="text-nowrap">{{ match.invoiceZohoNumber }}</td>
            <td class="text-nowrap">{{ formatConfidence(match.aiConfidence) }}</td>
            <td class="text-muted small text-nowrap">{{ match.zohoTransactionId }}</td>
            <td class="text-nowrap">
              <ng-container *ngIf="match.status === 'PENDING_REVIEW'">
                <button
                  class="btn btn-success btn-sm"
                  style="margin-right: 8px"
                  (click)="approveMatch(match)"
                  [disabled]="actionInProgress[match.id]">
                  Approve
                </button>
                <button class="btn btn-outline-secondary btn-sm" (click)="rejectMatch(match)" [disabled]="actionInProgress[match.id]">Reject</button>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="d-flex justify-content-between align-items-center mt-10" *ngIf="totalPages > 1">
      <small class="text-muted">{{ totalElements }} total matches</small>
      <nav>
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" [class.disabled]="currentPage === 0">
            <a class="page-link" (click)="goToPage(currentPage - 1)">Previous</a>
          </li>
          <li class="page-item" *ngFor="let p of pages" [class.active]="p === currentPage">
            <a class="page-link" (click)="goToPage(p)">{{ p + 1 }}</a>
          </li>
          <li class="page-item" [class.disabled]="currentPage === totalPages - 1">
            <a class="page-link" (click)="goToPage(currentPage + 1)">Next</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <!-- Categorization Table -->
  <div *ngIf="activeTab === 'categorization'">
    <div class="table-responsive">
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th>Date</th>
            <th>Status</th>
            <th>Bank Account</th>
            <th>Amount</th>
            <th>Payee</th>
            <th>Customer</th>
            <th>Allocation</th>
            <th>Confidence</th>
            <th>Tx ID</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loadingCategorizations">
            <td colspan="10" class="text-center py-20"><span class="spinner-border spinner-border-sm" role="status"></span> Loading...</td>
          </tr>
          <tr *ngIf="!loadingCategorizations && categorizations.length === 0">
            <td colspan="10" class="text-center py-20 text-muted">No categorization proposals found</td>
          </tr>
          <tr *ngFor="let categorization of loadingCategorizations ? [] : categorizations">
            <td class="text-nowrap">{{ formatTransactionDate(categorization.transactionDate) }}</td>
            <td>
              <span class="badge" [ngClass]="getStatusBadgeClass(categorization.status)">{{ categorization.status }}</span>
            </td>
            <td class="text-nowrap">{{ categorization.bankAccountName }}</td>
            <td class="text-nowrap">{{ formatAmount(categorization.transactionAmountEur) }}</td>
            <td class="payee-cell">
              <span class="payee-text" [title]="categorization.transactionReference">{{ categorization.transactionReference }}</span>
            </td>
            <td class="customer-cell">
              <span class="customer-text" [title]="categorization.proposedCustomerName">{{ categorization.proposedCustomerName }}</span>
            </td>
            <td class="allocation-cell">
              <div class="allocation-row" *ngFor="let allocation of categorization.allocations">
                <a href="javascript:void(0)" (click)="viewInvoice(allocation.invoiceId)">{{
                  allocation.invoiceZohoNumber || (allocation.invoiceId | slice: 0 : 8)
                }}</a>
                <span class="text-muted"> {{ formatAmount(allocation.amountAppliedEur) }} / {{ formatAmount(allocation.invoiceAmountDueEur) }}</span>
                <span class="badge ms-6" [ngClass]="allocation.fullPayment ? 'badge-success' : 'badge-warning'">
                  {{ allocation.fullPayment ? 'Paid' : 'Partial' }}
                </span>
              </div>
            </td>
            <td class="text-nowrap">{{ formatConfidence(categorization.aiConfidence) }}</td>
            <td class="text-muted small text-nowrap">{{ categorization.zohoTransactionId }}</td>
            <td class="text-nowrap">
              <ng-container *ngIf="categorization.status === 'PENDING_REVIEW'">
                <button
                  class="btn btn-success btn-sm"
                  style="margin-right: 8px"
                  (click)="approveCategorization(categorization)"
                  [disabled]="categorizationActionInProgress[categorization.id]">
                  Approve
                </button>
                <button
                  class="btn btn-outline-secondary btn-sm"
                  (click)="rejectCategorization(categorization)"
                  [disabled]="categorizationActionInProgress[categorization.id]">
                  Reject
                </button>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-10" *ngIf="categorizationTotalPages > 1">
      <small class="text-muted">{{ categorizationTotalElements }} total categorization proposals</small>
      <nav>
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" [class.disabled]="categorizationCurrentPage === 0">
            <a class="page-link" (click)="goToCategorizationPage(categorizationCurrentPage - 1)">Previous</a>
          </li>
          <li class="page-item" *ngFor="let p of categorizationPages" [class.active]="p === categorizationCurrentPage">
            <a class="page-link" (click)="goToCategorizationPage(p)">{{ p + 1 }}</a>
          </li>
          <li class="page-item" [class.disabled]="categorizationCurrentPage === categorizationTotalPages - 1">
            <a class="page-link" (click)="goToCategorizationPage(categorizationCurrentPage + 1)">Next</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>

<ng-template #detailsModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Invoice details</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div *ngIf="detailsLoading" class="text-center py-20"><span class="spinner-border spinner-border-sm" role="status"></span> Loading...</div>
    <dl *ngIf="invoice" class="description-list invoice-details">
      <dt class="text-muted">ID</dt>
      <dd>{{ invoice.id }}</dd>
      <ng-container *ngIf="invoice.zohoInvoiceNumber">
        <dt class="text-muted">Invoice number</dt>
        <dd>{{ invoice.zohoInvoiceNumber }}</dd>
      </ng-container>
      <dt class="text-muted">Created on</dt>
      <dd>{{ invoice.createdAt | date: 'medium' }}</dd>
      <ng-container *ngIf="invoice.paymentType === 'PREPAID' && invoice.rateApplied > 0">
        <dt class="text-muted">MT Rate</dt>
        <dd>€{{ invoice.rateApplied.toFixed(2) }}</dd>
      </ng-container>
      <ng-container *ngIf="invoice.paymentType === 'PREPAID' && invoice.initialAmount > 0">
        <dt class="text-muted">Top up amount</dt>
        <dd>€{{ invoice.initialAmount.toFixed(2) }}</dd>
      </ng-container>
      <ng-container *ngIf="invoice.paymentType === 'POSTPAID' && invoice.subtotal > 0">
        <dt class="text-muted">Subtotal</dt>
        <dd>€{{ invoice.subtotal.toFixed(2) }}</dd>
      </ng-container>
      <dt class="text-muted">VAT</dt>
      <dd>{{ invoice.vatPercentage > 0 ? invoice.vatPercentage : 0 }}%</dd>
      <dt class="text-muted">Total</dt>
      <dd>
        €{{ invoice.total ? invoice.total.toFixed(2) : '0' }}
        <span *ngIf="invoice.vatValue > 0"> + €{{ invoice.vatValue.toFixed(2) }} (VAT)</span>
      </dd>
      <dt class="text-muted">Paid</dt>
      <dd>
        <i *ngIf="invoice.paidAt" class="fas fa-check text-navy m-r"></i>
        <i *ngIf="!invoice.paidAt" class="fas fa-times text-danger m-r"></i>
      </dd>
      <dt class="text-muted">Customer</dt>
      <dd>{{ invoice.companyName || invoice.userEmail }}</dd>
    </dl>
  </div>
  <div class="modal-footer pt-15">
    <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Close</button>
  </div>
</ng-template>
